module.exports = __webpack_public_path__ + "media/images/athletes/1382-1cbd7eddb735b964195f4f4ff6ac552e.png";